/* eslint-disable @typescript-eslint/naming-convention */
import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'
import { useLocation } from 'react-router-dom'

export const InboundSupplyOrderWarehouseRBAC = {
  pageID: '821477bc08e9d840152a0f5afc0bc01e',
  elementID: {
    ViewContent: '71cdee5bdb5ba3a00c17c086f33f103e',
    MenuItemTiba: '0a446fc5f4fc943b76cee2f703d17f04',
    MenuItemCheckQty: '3440927413efc4628fb5b5229b44da6a',
    MenuItemStartUnloading: '68bd68d068769bb440f592f587146275',
    MenuItemConversion: '835e136aabefc46270445cf045a95ea1',
    MenuItemPrintGrn: '5511d6d0a3efc4624f82438e063cf03e',
  },
} as const

export const useRBACInboundSupplyOrderWarehousePage = createUseRBAC(
  InboundSupplyOrderWarehouseRBAC.elementID,
)
export type UseRBACInboundSupplyOrderWarehousePageType = ReturnType<
  typeof useRBACInboundSupplyOrderWarehousePage
>

export const InboundSupplyOrderHubRBAC = {
  pageID: 'd35f38ff312a9ea6b341f07bacfe8eda',
  elementID: {
    ViewContent: 'ac52b953c575816d6c97b55fe853262a',
    MenuItemTiba: '720177e6878e84d6e5139a04a98dec70',
    MenuItemCheckQty: '596bad5c2ed03287c60025a82e7b1ade',
    MenuItemStartUnloading: '18217584be0bdd16812cea5e31cca7f9',
    MenuItemConversion: 'a5c8e79056d03287a63c09ea18890e25',
    MenuItemPrintGrn: 'c69a16ff26d0328786039ff48336ffb2',
  },
} as const

export const useRBACInboundSupplyOrderHubPage = createUseRBAC(InboundSupplyOrderHubRBAC.elementID)
export type UseRBACInboundSupplyOrderHubPageType = ReturnType<
  typeof useRBACInboundSupplyOrderHubPage
>

// --- RBAC Selector ---
export const useInboundSupplyOrderRbac = () => {
  const { pathname } = useLocation()

  const rbacWarehouse = useRBACInboundSupplyOrderWarehousePage()
  const rbacHub = useRBACInboundSupplyOrderHubPage()

  if (pathname.includes('/inbound-so-hub')) return rbacHub
  if (pathname.includes('/inbound-so-warehouse')) return rbacWarehouse

  return {
    isAllowedForMenuItemTiba: false,
    isAllowedForMenuItemCheckQty: false,
    isAllowedForMenuItemConversion: false,
    isAllowedForMenuItemStartUnloading: false,
    isAllowedForMenuItemPrintGrn: false,
  }
}

export const filterInboundActions = (
  actionMenuList: { name: string }[],
  rbac: UseRBACInboundSupplyOrderWarehousePageType | UseRBACInboundSupplyOrderHubPageType,
) => {
  const {
    isAllowedForMenuItemTiba,
    isAllowedForMenuItemCheckQty,
    isAllowedForMenuItemConversion,
    isAllowedForMenuItemStartUnloading,
    isAllowedForMenuItemPrintGrn,
  } = rbac

  const rbacByName = {
    Tiba: isAllowedForMenuItemTiba,
    'Cek Quantity': isAllowedForMenuItemCheckQty,
    Konversi: isAllowedForMenuItemConversion,
    'Mulai Unloading': isAllowedForMenuItemStartUnloading,
    'Cetak GRN': isAllowedForMenuItemPrintGrn,
  }

  return actionMenuList.filter((item) => rbacByName[item.name as never] ?? true)
}
